/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhotoResource
 */
export interface PhotoResource {
    /**
     * 
     * @type {string}
     * @memberof PhotoResource
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResource
     */
    legend?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResource
     */
    deleteUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResource
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResource
     */
    baseUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof PhotoResource
     */
    cropped?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PhotoResource
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof PhotoResource
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof PhotoResource
     */
    originalMimeType?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResource
     */
    originalExtension?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResource
     */
    absoluteUrl?: string;
}

/**
 * Check if a given object implements the PhotoResource interface.
 */
export function instanceOfPhotoResource(value: object): value is PhotoResource {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('baseUrl' in value) || value['baseUrl'] === undefined) return false;
    return true;
}

export function PhotoResourceFromJSON(json: any): PhotoResource {
    return PhotoResourceFromJSONTyped(json, false);
}

export function PhotoResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhotoResource {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'legend': json['legend'] == null ? undefined : json['legend'],
        'deleteUrl': json['deleteUrl'] == null ? undefined : json['deleteUrl'],
        'type': json['type'] == null ? undefined : json['type'],
        'baseUrl': json['baseUrl'],
        'cropped': json['cropped'] == null ? undefined : json['cropped'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'originalMimeType': json['originalMimeType'] == null ? undefined : json['originalMimeType'],
        'originalExtension': json['originalExtension'] == null ? undefined : json['originalExtension'],
        'absoluteUrl': json['absoluteUrl'] == null ? undefined : json['absoluteUrl'],
    };
}

export function PhotoResourceToJSON(value?: PhotoResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'legend': value['legend'],
        'deleteUrl': value['deleteUrl'],
        'type': value['type'],
        'baseUrl': value['baseUrl'],
        'cropped': value['cropped'],
        'width': value['width'],
        'height': value['height'],
        'originalMimeType': value['originalMimeType'],
        'originalExtension': value['originalExtension'],
        'absoluteUrl': value['absoluteUrl'],
    };
}

